import React, { MouseEventHandler, Suspense, useState } from 'react';

import LoadingOverlay from 'atomic/loading-overlay';
import Link from 'atomic/link/link';
import { BadgePropsInterface, BadgeType } from 'interfaces/badge.interface';
import CompanyViewBadgeUsingCredibleReviewsModal
    from 'components/company-view/company-view-badges/modals/using-credible-reviews-modal';

const CompanyViewBadgeModal = React.lazy(() => import('components/company-view/company-view-badges/modals/badge-modal'));
const CompanyViewBadgeRankingModal = React.lazy(() => import('components/company-view/company-view-badges/modals/ranking-modal'));
const CompanyViewBadgeSskModal = React.lazy(() => import('components/company-view/company-view-badges/modals/ssk-modal'));

const Badge: React.FC<BadgePropsInterface> = props => {
    const [showModal, setShowModal] = useState(false);

    let modal;

    if (showModal) {
        switch (props.type) {
            case BadgeType.NORMAL:
                modal = (
                    <CompanyViewBadgeModal
                        onClose={(): void => setShowModal(false)}
                        item={props.item || {
                            name: '',
                            iconUrl: props.src,
                            type: 'OTHER'
                        }}
                    />
                );

                break;
            case BadgeType.SSK:
                modal = <CompanyViewBadgeSskModal onClose={(): void => setShowModal(false)}/>;

                break;
            case BadgeType.RANKING:
                modal = <CompanyViewBadgeRankingModal onClose={(): void => setShowModal(false)} item={props.item}/>;

                break;

            case BadgeType.CREDIBLE:
                modal = <CompanyViewBadgeUsingCredibleReviewsModal onClose={(): void => setShowModal(false)}/>;

                break;
        }
    }

    const handleClick: MouseEventHandler = e => {
        e.preventDefault();
        setShowModal(true);
    };

    return (
        <>
            <Link href="#" wrapper={true} onClick={handleClick}>
                <img src={props.src} alt={props.alt} title={props.alt} className={props.className}/>
            </Link>
            {showModal && (
                <Suspense fallback={<LoadingOverlay/>}>
                    {modal}
                </Suspense>
            )}
        </>
    );
};

export default Badge;
